module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"related_videos":"Related Videos","vip_badge":"VIP","svip_badge":"SVIP","annual_badge":"Annual","limited_tag":"Limited Availability","expired_tag":"Availability Ended","future_tag":"Upcoming"},"ja":{"related_videos":"関連動画","vip_badge":"VIP","svip_badge":"超VIP","annual_badge":"年間","limited_tag":"期間限定","expired_tag":"配信期間終了","future_tag":"近日配信"}}')
  delete Component.options._Ctor
}
